import { axiosInstance } from "@/plugins/axios";

export default {
  namespaced: true,
  state: {
    contentPages: [],
    contentPage: {},
    contentFaqs: [],
  },
  getters: {
    contentPages(state) {
      return state.contentPages;
    },
    contentPage(state) {
      return state.contentPage;
    },
    contentFaqs(state) {
      return state.contentFaqs;
    },
  },
  mutations: {
    SET_CONTENT_PAGES(state, value) {
      state.contentPages = value;
    },
    SET_CONTENT_PAGE(state, value) {
      state.contentPage = value;
    },
    SET_CONTENT_FAQS(state, value) {
      state.contentFaqs = value;
    },
  },
  actions: {
    async registerContentPages(context, value) {
      const url = value?.id ? `contentPages/${value.id}` : "contentPages";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultContentPages");
        });
    },
    async consultContentPages(context, value) {
      const url = value?.id ? `contentPages/${value.id}` : "contentPages";

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      if (value?.id) {
        context.dispatch("setDataDefault", ["SET_CONTENT_PAGE", data]);
        return;
      }
      context.dispatch("setDataDefault", ["SET_CONTENT_PAGES", data]);
    },
    async removeContentPage(context, id) {
      await axiosInstance({
        method: "DELETE",
        url: `contentPages/${id}`,
      });

      context.dispatch("consultContentPages");
    },
    async registerContentFaqs(context, value) {
      const url = value?.id ? `contentFaqs/${value.id}` : "contentFaqs";

      await axiosInstance({
        method: "POST",
        url: url,
        data: value,
      })
        .then((response) => response.data)
        .then(() => {
          context.dispatch("consultContentFaqs", value.id_specialties);
        });
    },
    async consultContentFaqs(context, idSpecialties) {
      let url = "contentFaqs";

      if (idSpecialties) {
        url = `contentFaqs/specialties/${idSpecialties}`;
      }

      const { data } = await axiosInstance({
        method: "GET",
        url: url,
      });

      context.dispatch("setDataDefault", ["SET_CONTENT_FAQS", data]);
    },
    async removeContentFaq(context, value) {
      await axiosInstance({
        method: "DELETE",
        url: `contentFaqs/${value.id}`,
      });

      context.dispatch("consultContentFaqs", value.id_specialties);
    },
    setDataDefault(context, [mutationName, value]) {
      context.commit(`${mutationName}`, value);
    },
  },
};
